
import React from 'react';
import { Button } from '../ui/button';
import { Download, Loader2 } from 'lucide-react';

interface DocumentHeaderProps {
  selectedDocumentsCount?: number | 0;
  handleDownloadSelected: () => Promise<void>;
  handleDownloadAll: () => Promise<void>;
  isDownloading?: boolean;
}

const DocumentHeader: React.FC<DocumentHeaderProps> = ({
  selectedDocumentsCount,
  handleDownloadSelected,
  handleDownloadAll,
  isDownloading = false,
}) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <h2 className="text-xl font-bold">Data Room</h2>
      <div className="flex gap-3">
        <Button
          onClick={handleDownloadSelected}
          disabled={selectedDocumentsCount === 0 || isDownloading}
          variant="outline"
        >
          {isDownloading ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <Download className="mr-2 h-4 w-4" />
          )}
          {isDownloading
            ? 'Downloading...'
            : `Download Selected ${selectedDocumentsCount && selectedDocumentsCount > 0 ? `(${selectedDocumentsCount})` : ''}`}
        </Button>
        <Button onClick={handleDownloadAll} disabled={isDownloading}>
          {isDownloading ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <Download className="mr-2 h-4 w-4" />
          )}
          {isDownloading ? 'Downloading...' : 'Download All'}
        </Button>
      </div>
    </div>
  );
};

export default DocumentHeader;
